<template>
    <el-drawer size="634px"
               class="custom_drawer"
               :withHeader="false"
               :visible.sync="ticketVisible"
               :close-on-press-escape="false"
               :wrapperClosable="false"
               :before-close="handleClickClose">
        <div class="drawer_wrap">
            <div class="drawer_header">
                <h3 class="title" v-text="ticketId ? '编辑商品' : '添加商品'"></h3>
                <span class="handle_icon_wrap" @click="handleClickClose">
                     <i class="el-icon-close" ></i>
                </span>
            </div>
            <div class="drawer_body" v-loading="loading">
                <div class="wechat_ticket_add_wrap" >
                    <div class="wechat_ticket_add_top">
                        <el-form ref="formData"  :model="formData"  :rules="formDataRules"  label-position="top"  size="small">


                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="选择商品平台" class="label-bold" prop="platform_id">
                                        <div class="add_platform flex_js_wrap" slot="label">
                                            <span>选择商品平台</span>
                                            <span class="add_platform_btn" @click.stop="handleClickAdd()"><i class="el-icon-plus"></i>添加平台</span>
                                        </div>
                                      <el-select v-model="formData.platform_id" placeholder="请选择平台">
                                          <el-option :value="item.id" :label="item.platform_name" v-for="(item,key) in platformList" :key="key">
                                              <span style="float: left">{{ item.platform_name }}</span>
                                              <span class="platform_edit_del" v-if="item.is_system == 0">
                                                  <span  class="handle_icon_wrap" @click.stop="handleClickEdit(item)"><i class="iconfont icon-bianji"></i></span>
                                                  <span  class="line"></span>
                                                  <span  class="handle_icon_wrap handle_icon_danger_wrap" @click.stop="handleClickDel(item,key)"><i class="iconfont icon-shanchu1"></i></span>
                                              </span>
                                          </el-option>
                                      </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="商品名称" class="label-bold" prop="ticket_name">
                                        <el-input placeholder="请输入商品名称" maxlength="30" v-model="formData.ticket_name"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="商品金额" class="label-bold" prop="price">
                                        <el-input placeholder="请输入商品金额"  v-model="formData.price" @blur="handleBlurPrice">
                                            <template slot="append">人民币</template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12"  v-if="formData.platform_id && formData.platform_id == 1">
                                    <el-form-item label="商品状态" class="label-bold" prop="is_upper">
                                        <el-select v-model="formData.is_upper">
                                            <el-option :value="1" label="上架"></el-option>
                                            <el-option :value="0" label="下架"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12"  v-if="formData.platform_id && formData.platform_id == 2">
                                    <el-form-item label="产品编码" class="label-bold" prop="product_code">
                                        <el-input placeholder="请输入产品编码" v-model="formData.product_code"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <template v-if="formData.platform_id &&  formData.platform_id == 1">
                                <el-form-item label="商品介绍" class="label-bold" prop="ticket_name_desc">
                                    <el-input placeholder="请输入商品介绍"  maxlength="200" type="textarea" v-model="formData.ticket_name_desc"></el-input>
                                </el-form-item>
                            </template>
                                <el-form-item label="商品封面图" class="label-bold" prop="cover">
                                    <div class="image_outer_wrap">
                                        <ul  class="upload_image_list">
                                            <li  class="upload_image_item" v-if="formData.cover">
                                                <i @click="formData.cover = ''" class="el-icon-error"></i>
                                                <el-image
                                                        :src="formData.cover"
                                                        fit="cover">
                                                </el-image>
                                            </li>
                                            <li class="image_upload_wrap" v-else>
                                                <input accept=".png, .jpg, .jpeg"
                                                       class="upload_input"
                                                       type="file"
                                                       @change="handleClickUploadImg($event,'cover')">
                                                <i class="el-icon-plus"></i>
                                            </li>
                                        </ul>
                                        <p class="image_hint">请上传750*400像素，格式为PNG/JPG，大小不超过5M的图片</p>
                                    </div>
                                </el-form-item>
                            <template v-if="formData.platform_id &&  formData.platform_id == 1">
                                <el-form-item label="商品详情轮播图" class="label-bold" prop="banner">
                                    <div class="image_outer_wrap">
                                        <ul  class="upload_image_list">
                                            <li v-for="(item,index) in formData.banner"
                                                :key="index"
                                                class="upload_image_item">
                                                <i @click="formData.banner.splice(index,1)" class="el-icon-error"></i>
                                                <el-image
                                                        :src="item.file_type.includes('image') ? item.file_path :  item.file_path + '?x-oss-process=video/snapshot,t_1000,m_fast'"
                                                        fit="cover">
                                                </el-image>

                                            </li>
                                            <li class="image_upload_wrap">
                                                <input accept=".png, .jpg, .jpeg, .mp4"
                                                       class="upload_input"
                                                       multiple
                                                       type="file"
                                                       @change="handleClickUploadImg($event,'banner')">
                                                <i class="el-icon-plus"></i>
                                            </li>
                                        </ul>
                                        <p class="image_hint">请上传750*400像素，格式为PNG/JPG，大小不超过5M的图片或不超过20M的mp4视频，最多5个</p>
                                    </div>
                                </el-form-item>
                                <el-form-item label="商品描述" class="label-bold" prop="detail">
                                    <WangEditor v-if="!loading" ref="detailWangEditorContent" v-model="formData.detail" :wangEditorText="formData.detail"></WangEditor>
                                </el-form-item>
                            </template>
                                <el-form-item label="购买须知" class="label-bold" prop="purchase_terms">
                                    <WangEditor v-if="!loading" ref="purchaseTermsWangEditorContent" v-model="formData.purchase_terms" :wangEditorText="formData.purchase_terms"></WangEditor>
                                </el-form-item>



                        </el-form>
                    </div>
                </div>
            </div>
            <div class="drawer_footer">
                <el-button size="small" @click="handleClickClose">取消</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">确定
                </el-button>
            </div>
        </div>
        <platformAddEdit :platformDialog.sync="platformDialog" :platformId="platformId"  :platformName="platformName" @success="getPlatformList" v-if="platformDialog" />

    </el-drawer>
</template>
<script>
import { ticketAddEdit,ticketDetail ,platformEdit,platformList,platformDel} from "@/api/index.js"
import { formatFileSize} from '@/utils'
import {uploadImg} from '@/utils/uploadOss'
import WangEditor from '@/components/pComponents/WangEditor'
import platformAddEdit from "../ticket_management/platform_edit"
export default {
    name: 'WeChatTicketAdd',
    components: {
        WangEditor,
        platformAddEdit
    },

    props: {
        ticketVisible: {
            type: Boolean,
            default: false,
        },
        ticketId: {
            type: Number,
            default: 0,
        },
    },
    data () {
        return {
            loading:false,
            btnDisabled:false,
            formData:{
                platform_id:'',
                ticket_name:'',
                price:'',
                ticket_name_desc:'',
                is_upper:1,
                cover:'',
                banner:[],
                detail:'',
                purchase_terms:'',

                product_code:'', //携程输入的产品编码
            },
            formDataRules:{
                platform_id: [{ required: true, message: '请选择商品平台',trigger: "change" }],
                ticket_name: [{ required: true, message: '请输入商品名称',trigger: "blur" }],
                price: [{ required: true, message: '请输入商品金额',trigger: "blur" }],
                is_upper: [{ required: true, message: '请选择商品状态',trigger: "change" }],
                cover: [{ required: true, message: '请上传商品封面图',trigger: "blur" }],
                banner: [{ required: true, message: '请上传商品详情轮播图',trigger: "blur" }],
                product_code: [{ required: true, message: '请输入产品编码',trigger: "blur" }],
            },
            platformList:[],
            platformId:0,
            platformName:'',
            platformDialog:false
        }
    },
    created() {
        this.getPlatformList()

    },
    computed: {

    },
    mounted () {

    },
    methods: {
        handleBlurPrice(){
          let price = this.formData.price.replace(',', '')
          price = this.formData.price.replace(/[^\d.]/g, '')
          if(price < 0){
              this.formData.price = 0
          }
          price = Number(price).toFixed(2)
          this.formData.price =  Number(price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        },
        getPlatformList(){
            platformList({}).then(res=> {
                if(res.code === 200) {
                    if(this.ticketId && this.platformList.length == 0){
                        this.getTicketDetail()
                    }
                    this.platformList = res.data
                }
            })
        },
        handleClickAdd(){
            this.platformId = 0
            this.platformName = ''
            this.platformDialog = true
        },
        handleClickEdit(item){
            this.platformId = item.id
            this.platformName = item.platform_name
            this.platformDialog = true
        },
        handleClickDel(item,key){
            const h = this.$createElement;
            this.$msgbox({
                title: '删除',
                message: h('div', null, [
                    h('span', null, '确定要删除该平台吗？小程序中核销平台也将一并删除'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText:   '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    id : item.id
                }
                this.loading = true
                platformDel(postData).then(res=> {
                    if(res.code === 200) {
                        this.$message.success('删除成功')
                        if(item.id == this.formData.platform_id){
                            this.formData.platform_id = ''
                        }
                        this.platformList.splice(key,1)
                    }
                    this.loading = false
                })
            }).catch(() => {

            })
        },
        // 获取详情
        getTicketDetail(){
            let postData = {
                ticket_id:this.ticketId
            }
            this.loading = true
            ticketDetail(postData).then(res=> {
                if(res.code === 200) {
                    let {platform_id,ticket_name,price,ticket_name_desc,is_upper,cover,banner,detail,purchase_terms,product_code} = res.data
                    this.formData.platform_id = platform_id
                    this.formData.ticket_name = ticket_name
                    this.formData.price = price
                    this.formData.ticket_name_desc = ticket_name_desc
                    this.formData.is_upper = is_upper
                    this.formData.cover = cover
                    this.formData.banner = banner
                    this.formData.detail = detail
                    this.formData.purchase_terms = purchase_terms
                    this.formData.product_code = product_code
                    if( this.platformList.findIndex(find => find.id == platform_id) <0){
                        this.formData.platform_id = ''
                    }
                    this.handleBlurPrice()
                }
                this.loading = false
            })
        },
        handleClickUploadImg(e, field) {
            const files = Array.from(e.target.files)
            if(field == 'banner'){
                if (this.formData.banner.length === 5) return this.$message.error('最多只能上传5张图片或视频')
                if(files.length + this.formData.banner.length > 5) return this.$message.error('最多只能上传5张图片或视频')
            }
            files.forEach(file => {
                if(field == 'banner'){
                    if(file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'video/mp4'){
                        this.$message.error(`${file.name}文件格式不正确`)
                        return false
                    }
                }else{
                    console.log(file);
                    if(file.type != 'image/png' && file.type != 'image/jpeg'){
                        this.$message.error(`${file.name}文件格式不正确`)
                        return false
                    }
                }
                let maxSize = file.type.includes('image') ? 5 : 20
                uploadImg(file, maxSize).then(res => {
                    if (res.file_path) {
                        if(field == 'banner'){
                            res.file_size = formatFileSize(file.size)
                            res.file_type = file.type
                            this.formData.banner.push(res)
                        }else{
                            this.formData.cover = res.file_path
                        }
                        this.$refs.formData.validateField(field)
                        e.target.value = ''
                    }
                }).catch(error => {
                    e.target.value = ''
                })

            })
        },
        // 取消
        handleClickClose(){
            this.$emit('update:ticketVisible', false)
        },
        // 确定
        handleClickConfirm(){
            this.$refs.formData.validate(valid => {
                if (valid) {
                    console.log(this.formData.price);
                    let postData = {
                        platform_id:this.formData.platform_id,
                        ticket_name:this.formData.ticket_name,
                        price:this.formData.price.replace(/,+/g, ''),
                        cover:this.formData.cover,
                        purchase_terms:this.$refs.purchaseTermsWangEditorContent.wangEditorValue
                    }
                    if(this.formData.platform_id == 1){
                        postData.ticket_name_desc = this.formData.ticket_name_desc
                        postData.is_upper = this.formData.is_upper
                        postData.banner = this.formData.banner
                        postData.detail = this.$refs.detailWangEditorContent.wangEditorValue
                    }else if(this.formData.platform_id == 2){
                        postData.product_code = this.formData.product_code
                    }
                    if(this.ticketId){
                        postData.id =  this.ticketId
                    }
                    this.btnDisabled = true

                    ticketAddEdit(postData).then(res=> {
                        if(res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '操作成功',
                                duration: 1500,
                                onClose: () => {
                                    this.btnDisabled = false
                                    this.handleClickClose()
                                    //父页面刷新列表
                                    this.$emit('success')
                                }
                            })
                        }else{
                            this.btnDisabled = false
                        }

                    })
                }else{
                    this.$message.error('请完善信息')
                }
            })
        },
    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
.danger_text{
    color: rgb(228, 65, 68);
}
.el-form-item{
    position: relative;
}
.add_platform{
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    line-height: 22px !important;
    padding-bottom: 0 !important;
    padding-left: 8px;
    margin-bottom: 4px;
    color: #333333;
    .add_platform_btn{
        cursor: pointer;
        color: rgba(41, 144, 255, 1);
        font-size: 12px;
    }
}
.platform_edit_del{
    float: right;
    display: none;
    font-size: 14px;
}
.el-select-dropdown__item:hover{
    .platform_edit_del{
        display: inline-block;
    }
}
</style>
